import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasOptions'
})
export class HasOptionsPipe implements PipeTransform {

  transform(items: any[]): any[] {
    return items?.filter(item => item?.hasOptions);
  }

}
